/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Messages_UnreadInputs */

const cs_messages_unread = /** @type {(inputs: Messages_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nepřečtených`)
};

const en_messages_unread = /** @type {(inputs: Messages_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unread`)
};

/**
* | output |
* | --- |
* | "{count} unread" |
*
* @param {Messages_UnreadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_unread = /** @type {((inputs: Messages_UnreadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_UnreadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_unread(inputs)
	return cs_messages_unread(inputs)
});